import { UserRole } from "../../store/store.model";

const effectiveRole = member => member.role === 'invited' ? member.invitedRole : member.role;

const isOwner = member => member.role === UserRole.Owner;

export const selectors = {
  effectiveRole,
  isOwner
};